"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildAncestryShape = void 0;
const zod_1 = require("zod");
exports.buildAncestryShape = {
    buildId: zod_1.z.string().optional(),
    projectId: zod_1.z.string().optional(),
    organizationId: zod_1.z.string().optional(),
};
//# sourceMappingURL=build-ancestry.js.map